module.exports = __webpack_public_path__ + "fd68a8912d303a6426b97c58684b02eb.png";